import apiHandler from "../core/apiHandler";

const testProgressApi = apiHandler("dte/test-progress");

export default testProgressApi;
